'use strict';

import ScrollMagic from 'scrollmagic/scrollmagic/uncompressed/ScrollMagic';
import 'scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
import 'scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';

/**
 * @classname ServiceParallax
 * @classdesc Serviceパララックス
 */
export default class ServiceParallax {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('ServiceParallax.constructor');
		this._controller = new ScrollMagic.Controller();
		this.photoAnimation();
		this.textAnimation();
	};


	/**
	 * 写真
	 *
	 * @memberof ServiceParallax
	 * @return {undefined}
	 */
	photoAnimation() {
		console.log('ServiceParallax.photoAnimation');
		new ScrollMagic.Scene({
			triggerElement: '.block--photo',
			triggerHook: 0.9
		})
		.setClassToggle('.block--photo', 'visible')
		.addTo(this._controller);
	};



	/**
	 * テキスト
	 *
	 * @memberof ServiceParallax
	 * @return {undefined}
	 */
	textAnimation() {
		console.log('ServiceParallax.textAnimation');
		new ScrollMagic.Scene({
			triggerElement: '.block--text',
			triggerHook: 0.9
		})
		.setClassToggle('.block--text', 'visible')
		.addTo(this._controller);
	};




};